import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "store/store";
import "nice-design/dist/index.css";
import "antd/dist/antd.css"; // 引入 antd 样式
import { GlobalStyle } from "./global-style";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyle whiteColor />
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
